const preferredAccessTypes = Object.freeze({
    physicalKey: 0, //KeyFob
    digitalKey: 1   //AccessPass
});

export default preferredAccessTypes;